import styled from "styled-components";

interface ResponsiveProps {
  $isPhone?: boolean;
  $lang?: string;
  $BgColor?: string;
  $TextColor?: string;
  $width?: string;
}

export const Wrapper = styled.div<ResponsiveProps>`
  padding: ${({ $isPhone }) => ($isPhone ? "20px" : "40px")};
`;

export const Title1 = styled.span<ResponsiveProps>`
  font-weight: 700;
  font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "16px")};
  display: block;
  text-align: start;
`;

export const StepIndicatorWrapper = styled.div<ResponsiveProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const StepIndicator = styled.span<{
  $isPhone: boolean;
  $isActive: boolean;
}>`
  width: 100%;
  height: ${({ $isPhone }) => ($isPhone ? "8px" : "14px")};
  background: ${({ $isActive }) => ($isActive ? "#5B3FFF" : "#EBECED")};
  border-radius: 35px;
  margin-inline: ${({ $isActive }) => ($isActive ? "" : "8px")};
`;
